(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jb-rebate-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rebate-carousel')) {
    customElements.define('rebate-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.controls = [...this.querySelectorAll('[data-go-to]')];
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = Number(this.dataset.speed) || 5000;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.querySelector('[data-previous]')?.addEventListener('click', () => this.show(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1, true));
        this.controls.forEach((control) => control.addEventListener('click', () => this.show(Number(control.dataset.goTo), true)));
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('[data-slide]');
          if (slide) this.show(Number(slide.dataset.slide), true);
        });
        this.start();
      }

      disconnectedCallback() {
        this.stop();
      }

      show(next, manual = false) {
        if (this.slides.length < 2) return;
        this.index = (next + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        this.controls.forEach((control) => {
          const active = Number(control.dataset.goTo) === this.index;
          control.classList.toggle('is-active', active);
          control.setAttribute('aria-selected', String(active));
          if (active && control.classList.contains('jb-rebate__thumbnail')) {
            control.scrollIntoView({ behavior: this.reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
          }
        });
        if (manual) this.start();
      }

      start() {
        this.stop();
        if (!this.autoplay || this.reducedMotion || this.slides.length < 2) return;
        this.timer = window.setInterval(() => this.show(this.index + 1), this.speed);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
